import React, { useEffect, useState } from 'react';
import './style.css';
import phoneCall from '../../images/free-icon-smartphone-call-15874.png';
import companyCall from '../../images/free-icon-telephone-49181.png';
import down from '../../images/Vector 1.png';

const HIDE_POPUP_KEY = 'hidePopupUntil';
const AD_VIDEO_URL =
  'https://www.youtube.com/embed/BFxsc2ScD28?autoplay=1&mute=1&playsinline=1&rel=0';

export default function Popup({ isOpen, handleClose }) {
  const [doNotShow, setDoNotShow] = useState(false);

  useEffect(() => {
    const hidePopupTime = localStorage.getItem(HIDE_POPUP_KEY);

    if (hidePopupTime && Date.now() < new Date(hidePopupTime).getTime()) {
      setDoNotShow(true);
    }
  }, []);

  const handleHideToday = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    localStorage.setItem(HIDE_POPUP_KEY, tomorrow.toISOString());
    setDoNotShow(true);
    handleClose();
  };

  if (!isOpen || doNotShow) return null;

  return (
    <div
      className="ant-popup"
      role="dialog"
      aria-modal="true"
      aria-label="앤츠네스트 소개 팝업"
    >
      <div className="ant-popup__backdrop" onClick={handleClose} />

      <div className="ant-popup__panel">
        <button
          className="ant-popup__close"
          type="button"
          onClick={handleClose}
          aria-label="팝업 닫기"
        >
          ×
        </button>

        <div className="ant-popup__body">
          <div className="ant-popup__media">
            <div className="ant-popup__frame">
              <iframe
                src={AD_VIDEO_URL}
                title="앤츠네스트 소개 영상"
                allow="autoplay; encrypted-media; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>

          <div className="ant-popup__info">
            <span className="ant-popup__badge">NEW · 앤츠네스트</span>
            <h2 className="ant-popup__title">
              아이디어를
              <br />
              <span className="ant-popup__title-accent">디지털 현실</span>로
              <br />
              전환합니다
            </h2>

            <p className="ant-popup__desc">
              웹사이트 · 애플리케이션 · 모바일 앱 개발 전문.
              <br />
              고객의 요구에 맞춘 <b>맞춤형 솔루션</b>을 제공합니다.
            </p>

            <div className="ant-popup__contact">
              <div className="ant-popup__contact-item">
                <img src={phoneCall} alt="" />
                <div>
                  <span>휴대폰</span>
                  <strong>010-7149-8147</strong>
                </div>
              </div>
              <div className="ant-popup__contact-item">
                <img src={companyCall} alt="" />
                <div>
                  <span>회사번호</span>
                  <strong>070-7797-0814</strong>
                </div>
              </div>
            </div>

            <a
              className="ant-popup__cta"
              href="https://antsnest.co.kr/files/Antsnest_SI.pptx"
              download="Antsnest_SI.pptx"
            >
              앤츠네스트 소개서 다운로드
              <img src={down} alt="" />
            </a>
          </div>
        </div>

        <div className="ant-popup__footer">
          <label className="ant-popup__hide">
            <input
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) handleHideToday();
              }}
            />
            <span>오늘 하루 보지 않기</span>
          </label>
          <button
            type="button"
            className="ant-popup__dismiss"
            onClick={handleClose}
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}
